import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

export default class PageProjects extends Component {
	state = {
		activeIndex: -1
	};
	
	handleMouseOver = (event) => {
    	this.setState({ activeIndex: parseFloat(event.currentTarget.getAttribute('data-index')) });
  	};
  	
  	handleMouseOut = (event) => {
    	this.setState({ activeIndex: -1 });
  	};
  	
	render() {
		
		const block = this.props.block; 
				
		return (
			
			<div className={'c-page__block c-page__block--load-effect'}>
			    
				<div className="c-projects l-content">
					
					<h2 className="c-projects__heading" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
					<h4 className="c-projects__subheading" dangerouslySetInnerHTML={{__html:'(01 - 0' + block.projects.length + ') <svg class="c-arrow" x="0px" y="0px" viewBox="0 0 46 36"><path style="fill:#2C2C2C" d="M22.22,0.05l15.78,15.89H0.46v3.93h37.71L22.22,35.95h5.44L45.54,18L27.65,0.05H22.22 z"/></svg>'}}></h4>
					<div>
					
						{block.projects.map((project,i) =>
							{
								let _color 		= '#2C2C2C';
								let _bgColor 	= '#FFF';
								if (i === this.state.activeIndex) {
									_bgColor = project.color;
									if (project.text_color === 'light') {
										_color = '#FFF';
									}
								}
								return (
									<Link className="c-projects__block" to={{ pathname: '/project/' + project.slug }} key={i} style={{backgroundColor:_bgColor}} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} data-index={i}>
											
										<div className="c-projects__block__text">
											<div className="c-projects__block__text__top">
												<h5 className="c-projects__block__text__type" dangerouslySetInnerHTML={{__html:project.type}} style={{color:_color}}></h5>
												<h5 className="c-projects__block__text__status" dangerouslySetInnerHTML={{__html:project.status}} style={{color:_color}}></h5>
											</div>
											<h3 className="c-projects__block__text__heading" dangerouslySetInnerHTML={{__html:project.heading + '<br/><span style="color:' + _color + ';">(0' + (i + 1) + ')<br />' + project.suburb + '</span>'}} style={{color:_color}}></h3>
											<p className="c-projects__block__text__more"  dangerouslySetInnerHTML={{__html:'View more <svg class="c-arrow" x="0px" y="0px" viewBox="0 0 46 36"><path style="fill:' + _color + '" d="M22.22,0.05l15.78,15.89H0.46v3.93h37.71L22.22,35.95h5.44L45.54,18L27.65,0.05H22.22 z"/></svg>'}} style={{color:_color}}></p>
										</div>
										<div className="c-projects__block__image">
											<div className="c-projects__block__image__inner">
												<FadeIn key={i}>
													{onload => (
														<img
															alt={''} 
															src={project.src} 
															srcSet={project.srcset} 
															onLoad={onload}
														/>
													)}
												</FadeIn>
											</div>
										</div>
									</Link>
								)
							}
						)}
						
					</div>
				
				</div>
				
			</div>
				
		)
		
	}
							
}